module.exports = __webpack_public_path__ + "static/media/bootstrap.43e1b655.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/bootstrap.png
// module id = 77
// module chunks = 0